import { gql } from '@apollo/client'

export const PRESCRIPTIONS = gql`
  query PRESCRIPTIONS(
    $branchId: ID
    $userId: ID
    $doctor: ID
    $assignedToId: ID
    $id: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $filters: Filter
    $appointment: ID
    $operation: ID
    $operationStep: ID
  ) {
    prescriptions(
      branchId: $branchId
      userId: $userId
      doctor: $doctor
      assignedToId: $assignedToId
      patient: $id
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      filters: $filters
      appointment: $appointment
      operation: $operation
      operationStep: $operationStep
    ) {
      id
      details
      name
      diagnosis
      advice
      followUpDate
      seen
      medication
      patient {
        id
        firstName
        lastName
        birthDate
        title
        phoneNumber
        referenceId
        patientId
        nationalId
      }
      doctor {
        id
        name
      }
      users {
        id
        name
      }
      branch {
        id
        name
      }
      appointment {
        id
        start
        status
        end
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`

export const PRESCRIPTION_DETAILS = gql`
  query PRESCRIPTION_DETAILS($prescription: ID!, $token: String) {
    prescriptionDetails(prescription: $prescription, token: $token) {
      id
      details
      name
      diagnosis
      advice
      followUpDate
      seen
      medication
      patient {
        id
        firstName
        lastName
        birthDate
        title
        phoneNumber
        referenceId
        patientId
        nationalId
      }
      doctor {
        id
        name
      }
      users {
        id
        name
      }
      branch {
        id
        name
      }
      appointment {
        id
        start
        status
        end
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`

export const TOTAL_PRESCRIPTIONS = gql`
  query TOTAL_PRESCRIPTIONS(
    $branchId: ID
    $userId: ID
    $assignedToId: ID
    $doctor: ID
    $id: ID
    $rangeDate: [DateTime!]!
    $filters: Filter
    $appointment: ID
    $operation: ID
    $operationStep: ID
  ) {
    totalPrescriptions(
      branchId: $branchId
      userId: $userId
      assignedToId: $assignedToId
      doctor: $doctor
      patient: $id
      rangeDate: $rangeDate
      filters: $filters
      appointment: $appointment
      operation: $operation
      operationStep: $operationStep
    )
  }
`
export const MEDICALS = gql`
  query MEDICALS($appointment: ID, $patient: ID) {
    medicals(appointment: $appointment, patient: $patient) {
      id
      name
      order
      showAlert
      active
      items {
        id
        name
        type
        order
        hidden
        required
        options
        active
        gender
        createdAt
        updatedAt
        createdBy {
          id
          name
        }
        updatedBy {
          id
          name
        }
      }
    }
  }
`
export const GET_MEDICATIONS_FOR_MEDICAL = gql`
  query GET_MEDICATIONS_FOR_MEDICAL($patient: ID) {
    getMedicationsForMedical(patient: $patient) {
      id
      name
      dosage
      type
      method
      strength
    }
  }
`
export const CLINICAL = gql`
  query CLINICAL {
    clinical {
      id
      name
      order
      active
      items {
        id
        name
        required
        type
        order
        options
        active
        createdAt
        updatedAt
        createdBy {
          id
          name
        }
        updatedBy {
          id
          name
        }
      }
    }
  }
`
export const CONDITIONS = gql`
  query CONDITIONS($chart: ChartTypes) {
    conditions(chart: $chart) {
      id
      name
      code
      order
      image
      active
      items {
        id
        name
        order
        code
        active
        toothEffect
        createdAt
        updatedAt
        createdBy {
          id
          name
        }
        updatedBy {
          id
          name
        }
      }
    }
  }
`
export const GET_PROCEDURES = gql`
  query GET_PROCEDURES($chart: ChartTypes, $priceList: ID) {
    procedures(chart: $chart, priceList: $priceList) {
      id
      name
      order
      code
      image
      active
      items {
        id
        name
        code
        order
        defaultPrice
        toothEffect
        openLab
        ageGroup
        active
        taxApplied
        insuranceDiscount
        cost
        forOperator
        isPercent
        remaining
        requireOperationCounter
        productPriceId
        labFees
        allowMaxLimit
        createForm
        createLabOrder
        createPrescription
        expires
        requireCounter
        insuranceValue
        prices {
          id
          value
          name
          code
          active
          allowMaxLimit
          forOperator
          isPercent
          insuranceDiscount
          insuranceValue
          productPriceId
          parentId
        }
      }
    }
  }
`

export const PROCEDURE_STEP_DETAILS = gql`
  query PROCEDURE_STEP_DETAILS($procedureStep: ID!) {
    procedureStepDetails(procedureStep: $procedureStep) {
      id
      name
      order
      forOperator
      labFees
      isPercent
      openLab
      createForm
      createLabOrder
      createPrescription
      appointmentType
      other
      appointmentAfter
      percentOfOperation
      updateInvoiceRequired
      isPercentInvoiceRequired
      freeForms {
        id
        name
        signRequired
      }
      labItems {
        id
        name
      }
      prescriptions {
        id
        name
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`

export const PROCEDURE_STEPS = gql`
  query PROCEDURE_STEPS($procedure: ID!) {
    procedureSteps(procedure: $procedure) {
      id
      name
      order
      forOperator
      labFees
      isPercent
      openLab
      createForm
      createLabOrder
      createPrescription
      appointmentType
      other
      appointmentAfter
      percentOfOperation
      updateInvoiceRequired
      isPercentInvoiceRequired
      freeForms {
        id
        name
        signRequired
      }
      labItems {
        id
        name
      }
      prescriptions {
        id
        name
      }
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const GET_PRICE_LISTS = gql`
  query GET_PRICE_LISTS {
    priceLists {
      id
      name
      syncTo
      percentage
      difference
      active
      branches {
        id
        name
      }
    }
  }
`
export const TOTAL_MEDICATIONS = gql`
  query TOTAL_MEDICATIONS($searchTerm: String) {
    totalMedications(searchTerm: $searchTerm)
  }
`
export const GET_MEDICATIONS = gql`
  query GET_MEDICATIONS($orderBy: String!, $skip: Int!, $take: Int!, $searchTerm: String) {
    medications(orderBy: $orderBy, skip: $skip, take: $take, searchTerm: $searchTerm) {
      id
      name
      dosage
      dispense
      type
      sig
      duration
      method
      details
      strength
      createdAt
      updatedAt
      customFields {
        id
        value
        field {
          id
        }
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const GET_ALL_MEDICATIONS = gql`
  query GET_ALL_MEDICATIONS {
    getAllMedications {
      id
      name
      dosage
      dispense
      type
      sig
      duration
      method
      details
      strength
    }
  }
`

export const SEARCH_MEDICATIONS = gql`
  query SEARCH_MEDICATIONS($searchTerm: String!) {
    searchMedications(searchTerm: $searchTerm) {
      id
      name
      dosage
      dispense
      type
      sig
      duration
      method
      details
      strength
      images
    }
  }
`
export const MEDICATION_DETAILS = gql`
  query MEDICATION_DETAILS($medication: ID!) {
    medicationDetails(medication: $medication) {
      id
      name
      dosage
      dispense
      type
      sig
      duration
      method
      details
      strength
      createdAt
      updatedAt
      customFields {
        id
        value
        field {
          id
        }
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
    }
  }
`
export const NOTE_TEMPLATES = gql`
  query NOTE_TEMPLATES {
    noteTemplates {
      id
      name
      code
      order
      active
      items {
        id
        name
        order
        code
        active
        createdAt
        updatedAt
        createdBy {
          id
          name
        }
        updatedBy {
          id
          name
        }
      }
    }
  }
`

export const PROCEDURES = gql`
  query PROCEDURES(
    $userId: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $filters: Filter
    $searchTerm: String
    $procedureGroup: ID
    $priceList: ID
    $forDoctorPercent: Boolean
    $doctor: ID
  ) {
    getProcedures(
      userId: $userId
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      filters: $filters
      searchTerm: $searchTerm
      procedureGroup: $procedureGroup
      priceList: $priceList
      forDoctorPercent: $forDoctorPercent
      doctor: $doctor
    ) {
      id
      code
      name
      active
      chart
      group {
        id
        name
      }
      toothEffect
      insuranceDiscount
      insuranceValue
      openLab
      ageGroup
      order
      defaultPrice
      cost
      forOperator
      isPercent
      createForm
      createLabOrder
      createPrescription
      createdAt
      expires
      allowMaxLimit
      taxApplied
      productPriceId
      requireCounter
      prices {
        id
        value
        name
        code
        active
        forOperator
        isPercent
        insuranceDiscount
        diagnosis
        insuranceValue
        productPriceId
        discount
        allowMaxLimit
        discountIsPercent
        parentId
      }
      doctorPercent {
        id
        forOperator
        labFees
        isPercent
        priceListId
        doctorId
      }
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`

export const PROCEDURE_DETAILS = gql`
  query PROCEDURE_DETAILS($procedure: ID!, $priceList: ID, $forDoctorPercent: Boolean, $doctor: ID) {
    procedureDetails(procedure: $procedure, priceList: $priceList, forDoctorPercent: $forDoctorPercent, doctor: $doctor) {
      id
      code
      name
      active
      chart
      group {
        id
        name
      }
      toothEffect
      insuranceDiscount
      openLab
      ageGroup
      defaultPrice
      cost
      forOperator
      isPercent
      createForm
      createLabOrder
      createPrescription
      order
      remaining
      allowMaxLimit
      productPriceId
      labFees
      expires
      requireCounter
      requireOperationCounter
      insuranceValue
      freeForms {
        id
        name
        signRequired
      }
      labItems {
        id
        name
      }
      prescriptions {
        id
        name
      }
      steps {
        id
        name
        createPrescription
        createForm
        createLabOrder
        freeForms {
          id
          name
          signRequired
        }
        labItems {
          id
          name
        }
        prescriptions {
          id
          name
        }
        doctorPercent {
          id
          forOperator
          labFees
          isPercent
          doctorId
          priceListId
        }
      }
      createdAt
      updatedAt
    }
  }
`

export const TOTAL_PROCEDURES = gql`
  query TOTAL_PROCEDURES($userId: ID, $rangeDate: [DateTime!]!, $filters: Filter, $searchTerm: String, $procedureGroup: ID) {
    totalProcedures(
      userId: $userId
      rangeDate: $rangeDate
      filters: $filters
      searchTerm: $searchTerm
      procedureGroup: $procedureGroup
    )
  }
`

export const GET_CONDITIONS = gql`
  query GET_CONDITIONS(
    $userId: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $filters: Filter
    $searchTerm: String
    $group: ID
  ) {
    getConditions(
      userId: $userId
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      filters: $filters
      searchTerm: $searchTerm
      group: $group
    ) {
      id
      code
      name
      active
      chart
      group {
        id
        name
      }
      toothEffect
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`

export const CONDITIONS_DETAILS = gql`
  query CONDITIONS_DETAILS($condition: ID!) {
    conditionsDetails(condition: $condition) {
      id
      code
      name
      active
      chart
      group {
        id
        name
      }
      toothEffect
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
      _count {
        operations
      }
    }
  }
`

export const TOTAL_CONDITIONS = gql`
  query TOTAL_CONDITIONS($userId: ID, $rangeDate: [DateTime!]!, $filters: Filter, $searchTerm: String, $group: ID) {
    totalConditions(userId: $userId, rangeDate: $rangeDate, filters: $filters, searchTerm: $searchTerm, group: $group)
  }
`

export const PRICE_LISTS = gql`
  query PRICE_LISTS(
    $userId: ID
    $orderBy: String!
    $skip: Int!
    $take: Int!
    $rangeDate: [DateTime!]!
    $filters: Filter
    $searchTerm: String
  ) {
    getPriceLists(
      userId: $userId
      orderBy: $orderBy
      skip: $skip
      take: $take
      rangeDate: $rangeDate
      filters: $filters
      searchTerm: $searchTerm
    ) {
      id
      name
      syncTo
      active
      percentage
      difference
      branches {
        id
        name
      }
      createdAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      updatedAt
    }
  }
`

export const TOTAL_PRICE_LISTS = gql`
  query TOTAL_PRICE_LISTS($userId: ID, $rangeDate: [DateTime!]!, $filters: Filter, $searchTerm: String) {
    totalPriceLists(userId: $userId, rangeDate: $rangeDate, filters: $filters, searchTerm: $searchTerm)
  }
`
